import type { ReactNode } from 'react';

import { cn } from '@muzly/lib/utils';

/**
 * SurveyBanner — 설문·안내 화면의 "왜 묻는지" 배너 (시안 §2).
 *
 * 배경 `rgba(251,35,59,0.03)` = 브랜드 레드 3%. 이 옅기가 요점이다: 경고가 아니라
 * 곁들이는 설명이라, 진한 레드로 두면 답을 잘못 골랐다는 신호로 읽힌다. 같은 이유로
 * 아이콘도 채운 원이 아니라 테두리 원이다.
 *
 * 별도 컴포넌트인 이유는 설문 8단계 말고도 진단 안내·완료 화면이 같은 배너를 쓰기
 * 때문이다 — 화면마다 rgba를 다시 적으면 한 곳만 다른 옅기로 갈린다.
 */
export const SurveyBanner = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      'flex items-center gap-2 rounded-2xl bg-primary/[0.03] px-4 py-3.5',
      className,
    )}
  >
    <span
      aria-hidden="true"
      className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-[1.5px] border-primary text-[13px] font-bold leading-none text-primary"
    >
      !
    </span>
    <p className="whitespace-pre-line text-sm font-medium leading-[1.5] tracking-[-0.07px] text-foreground">
      {children}
    </p>
  </div>
);
